const PLATFORM_AVATARS = {
  facebook: require("@/assets/testimonials/Facebook.jpg"),
  instagram: require("@/assets/testimonials/Instagram.jpg"),
  tiktok: require("@/assets/testimonials/TikTok.jpg"),
};

const TESTIMONIAL_IMGS = {
  facebook: require("@/assets/testimonials/desc1.jpg"),
  instagram: require("@/assets/testimonials/desc2.jpg"),
  tiktok: require("@/assets/testimonials/desc3.jpg"),
};

/** 为各平台评价附加头像与 testimonials 配图 */
export function enrichReviewPlatforms(platforms) {
  return platforms.map((platform) => ({
    ...platform,
    logo: PLATFORM_AVATARS[platform.id] || null,
    reviews: platform.reviews.map((review) => ({
      ...review,
      image: TESTIMONIAL_IMGS[platform.id] || null,
    })),
  }));
}
